import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const setGamePartners = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			internal_game_id: data.game_id,
			partners: data.partners,
			action: data.action || 'replace',
			request: 'SetGamePartners',
		})
		.then((res) => {
			if (res.data?.resultCode !== 0) {
				throw new Error(res.data?.errorMessage || 'Failed to set game partners');
			}
			return res.data;
		});
